import { WalletConnectConnector } from '@web3-react/walletconnect-connector';
import { InjectedConnector } from '@web3-react/injected-connector';

export const injected = new InjectedConnector({ supportedChainIds: [137] });

export const walletconnect = new WalletConnectConnector({
  rpc: { 1: 'https://polygon-rpc.com' },
  qrcode: true
})


// import { WalletConnectConnector } from '@web3-react/walletconnect-connector';
// import { InjectedConnector } from '@web3-react/injected-connector';

// export const injected = new InjectedConnector({ supportedChainIds: [137, 3] });

// export const walletconnect = new WalletConnectConnector({
//   rpc: { 1:'https://ropsten.infura.io/v3/6df3f86696a34e89933b7cb90e315afd', 2: 'https://polygon-rpc.com' },
//   qrcode: true
// })